function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncatched exception popping up in devtools
	return Promise.resolve().then(function() {
		throw new Error("Cannot find module '" + req + "'.");
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./src/main/webapp/stay-mgmt/$$_gendir lazy recursive";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/$$_gendir lazy
// module id = ./src/main/webapp/stay-mgmt/$$_gendir lazy recursive
// module chunks = 0